import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const XLSIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16" fill="none"  >
    <path fill="none" d="M2 2.5C2 2.22386 2.22386 2 2.5 2H10V4.5C10 4.77614 10.2239 5 10.5 5H13V14.5C13 14.7761 12.7761 15 12.5 15H2.5C2.22386 15 2 14.7761 2 14.5V2.5Z" stroke="#2B3940" strokeWidth="1.75" />
    <path d="M6.67599 10.004L4.87199 7.172H6.22399C6.31199 7.172 6.37599 7.184 6.41599 7.208C6.45865 7.22933 6.49599 7.26666 6.52799 7.32L7.68799 9.284C7.70132 9.24933 7.71599 9.216 7.73199 9.184C7.75065 9.152 7.77065 9.11866 7.79199 9.084L8.80799 7.34C8.87465 7.228 8.96532 7.172 9.07999 7.172H10.376L8.54799 9.944L10.416 13H9.06399C8.97599 13 8.90399 12.9787 8.84799 12.936C8.79465 12.8933 8.75199 12.8427 8.71999 12.784L7.55199 10.744C7.53065 10.8027 7.50665 10.8533 7.47999 10.896L6.39199 12.784C6.35999 12.84 6.31732 12.8907 6.26399 12.936C6.21065 12.9787 6.14399 13 6.06399 13H4.79999L6.67599 10.004Z" fill="#2B3940" />
  </SvgIcon>
);
XLSIcon.displayName = "XLSIcon";
XLSIcon.muiName = "SvgIcon";

export default pure(XLSIcon);